/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { TypeLoader } from "src/constants/theme.constant";
import { Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';

interface LoaderProps {
  type?: TypeLoader,
  fullPage?: boolean,
  text?: string,
};

const Loader = ({
  type = TypeLoader.Default,
  fullPage = false,
  text = '',
} : LoaderProps) => {
  //TODO: Loader general de la app y sus variaciones uso temporal de spin de antd
  return (
    <>
      {fullPage ? (
        <div className="loader-fullpage">
          <div>
            <Spin indicator={<LoadingOutlined spin />} size="large" /><br />
            <span className="loader-fullpage__label">{text}</span>
          </div>
        </div>
      ) : (
        <Spin indicator={<LoadingOutlined spin />} />
      )}
    </>
  );
};

export default Loader;
